import { Button } from '@cian/ui-kit';
import { IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectIsHotelSearch } from 'shared/selectors/jsonQuery';
import { selectPageType } from 'shared/selectors/page/selectPageType';
import { dispatchSaveSearchButtonClickEvent } from 'shared/utils/event';

/**
 * Кнопка сохранения поиска
 * Она тут не должна быть
 * TODO: сделать тех проект по вынесению кнопки в отдельный микрофронт (сейчас там только модалка в мкф)
 * Код можно посмотреть в мкс-потребителях: frontend-serp и map-search-frontend
 */
export const SaveSearchButtonContainer: FC = () => {
  const isHotelSearch = useSelector(selectIsHotelSearch);
  const pageType = useSelector(selectPageType);

  if (isHotelSearch || pageType === 'main') {
    return null;
  }

  return (
    <Button
      theme="fill_white_primary"
      size="XS"
      beforeIcon={<IconToggleHeartOff16 color="icon-main-default" />}
      onClick={dispatchSaveSearchButtonClickEvent}
    >
      Сохранить поиск
    </Button>
  );
};
